export default [
  {
    type: 'input',
    placeholder: '账号',
    filed: 'account',
    default: ''
  },
  {
    type: 'select',
    placeholder: '账号类型',
    filed: 'adminType',
    default: '',
    options: [
      {
        code: 2,
        name: '售后用户'
      },
      {
        code: 3,
        name: '平台与APP'
      }
    ]
  }
]
